/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { Component, Inject, OnInit, Optional } from '@angular/core';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { CookieService } from 'ngx-cookie-service';
import {Router} from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';


interface ResourceServerExample {
  label: string;
  url: string;
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {
  resourceServerExamples: Array<ResourceServerExample>;
  userName: string;
  isAuthenticated: boolean;
  error: Error;

  token: string;
  roomId: string;

  constructor(
    public oktaStateService: OktaAuthStateService,
    private cookieService: CookieService,
    private router: Router,
    @Optional() @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    ) {
    this.resourceServerExamples = [
      {
        label: 'Node/Express Resource Server Example',
        url: 'https://github.com/okta/samples-nodejs-express-4/tree/master/resource-server',
      },
      {
        label: 'Java/Spring MVC Resource Server Example',
        url: 'https://github.com/okta/samples-java-spring-mvc/tree/master/resource-server',
      },
    ];
    this.oktaStateService.authState$.subscribe(auth => this.isAuthenticated = auth.isAuthenticated);
  }

  async login(): Promise<void> {
    try {
      await this.oktaAuth.token.getWithRedirect({
        responseType: ['id_token', 'token'],
        scopes: ['openid', 'email', 'profile']
      });
    } catch (err) {
      console.error(err);
      this.error = err;
    }
  }

  async ngOnInit(): Promise<void> {

    this.token = this.cookieService.get('myspotToken');
    this.roomId = this.cookieService.get('roomId');

    if (!this.token || !this.roomId) {
      this.isAuthenticated = await this.oktaAuth.isAuthenticated();
      if (this.isAuthenticated) {
        this.router.navigate(['config']);
      } else {
        this.cookieService.deleteAll();
        console.log('login');
      }
    } else {
      this.isAuthenticated = await this.oktaAuth.isAuthenticated();
      if (this.isAuthenticated) {
        this.oktaAuth.signOut();
      }
      this.router.navigate(['room-panel']);
    }
  }
}
